import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IMessage} from 'react-native-gifted-chat';
import {ChatbotMessage} from '../../../../shared/models/api';
import {AppActions} from '../../../actions';
import {buildMessage} from './helpers';
import {IMessageModified} from './model';

export interface ChatbotState {
  messages: IMessage[];
  answer: IMessage | null;
  isLoading: boolean;
  isGeneralQuestion: boolean | null;
  isUsefulAnswer: boolean;
  isError: boolean;
}

const initialState: ChatbotState = {
  messages: [],
  answer: null,
  isLoading: false,
  isGeneralQuestion: null,
  isUsefulAnswer: false,
  isError: false,
};

export const chatbotSlice = createSlice({
  name: '@@eskso/socialSupport/chatbot',
  initialState,
  reducers: {
    setMessages: (state, {payload}: PayloadAction<ChatbotMessage | ChatbotMessage[]>) => {
      const newMessages = Array.isArray(payload) ? payload.map(buildMessage) : [buildMessage(payload)];
      const messagesMap = new Map<string | number, IMessageModified>();

      for (const item of state.messages) {
        messagesMap.set(item._id, item);
      }

      for (const item of newMessages) {
        messagesMap.set(item._id, item);
      }

      const messages = Array.from(messagesMap.values());

      state.isGeneralQuestion = messages[messages.length - 1].general ?? null;
      state.isUsefulAnswer = messages[messages.length - 1].useful ?? false;
      state.messages = messages;
    },
    removeMessageLocally: (state, {payload}: PayloadAction<string | number>) => {
      state.messages = state.messages.filter((message) => message._id !== payload);
    },
    setChatbotLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setChatbotError: (state, action: PayloadAction<boolean>) => {
      state.messages = [];
      state.isError = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const chatbotActions = chatbotSlice.actions;

export const chatbot = chatbotSlice.reducer;
